<template>
    <div class="modal"
        :class="{'is-active': isActive}"
    >
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <slot>
                    <div class="notification is-warning">Nothing to show</div>
                </slot>
            </div>
        </div>
        <button @click="closeModal" class="modal-close is-large" :aria-label="$t('close')">{{ $t('close') }}</button>
    </div>
</template>

<script>
import eventBus from '@/tools/eventBus';

export default {
    props: {
        element: String
    },
    methods: {
        openModal(e) {
            this.isActive = this.element === e.modalName;
        },
        closeModal() {
            this.isActive = false;
        }
    },
    data() {
        eventBus.$on('open', e => { this.openModal(e); });
        return {
            isActive: false
        };
    }
}
</script>

<style scoped>

</style>

<i18n>
{
    "en": {
        "close": "Close"
    },
    "fi": {
        "close": "Sulje"
    }
}
</i18n>
